import axios from 'axios';
import localDefs from '../../assets/icons/svgdefs.svg';
import {sanitize} from 'dompurify';

function loadSVG(defs) {
	axios
		.get(defs, {
			responseType: 'text'
		})
		.then(({data}) => {
			let parser = new DOMParser();
			let doc = parser.parseFromString(sanitize(data), 'application/xml');
			document.body.appendChild(doc.documentElement);
		});
}

console.log('Loading SVG');
loadSVG(localDefs);
